export const SNIPPET = 'snippet-productDetail-carousel';
